import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
    name: 'ticket-caisse',
    components: {},
    props: {
        paiement_data: Object,
        caissiere: String,
        patient: Object,
        ticket_caisse_info: Object
    },
    data() {
        return {
            is_printing: false,
            is_ticket: true,
            types_ticket: [
                { id: 1, format: "pos58", libelle: "Papier thermique 58mm" },
                { id: 2, format: "pos80", libelle: "Papier thermique 80mm" }
            ],
            type_ticket: '',
            type_ticket_is_empty: false,
            format: '',
            date_ticket: '',
            nom_clinique: '',
            filename: 'Ticket_caisse',
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {

        nextToPrint() {
            if (this.type_ticket == '') {
                this.type_ticket_is_empty = true
                return;
            }

            this.format = this.type_ticket.format
            this.is_ticket = true

            this.date_ticket = new Date()
        },

        setFileName() {
            // this.is_printing = true
            let d  = new Date()
            this.filename = 'Ticket_caisse_'+this.patient.nom+' '+this.patient.prenoms+'_'+d.getTime()

            setTimeout(() => {
                window.print()
            }, 200);
            
        },

        backToChoice() {
            this.is_ticket = false
        },

        clearError() {
            this.type_ticket_is_empty = false
        },
    }
}